import React from 'react';
import Table from '../../components/common/Table';

interface LeadFileTableProps {
  data: any[];
  handleDownload: (service: any) => void;
  handleDelete: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const LeadFileTable: React.FC<LeadFileTableProps> = ({
  data,
  handleDownload,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                {
          label: "File Name",
          key: "fileName",
          render: (file) => (
            <span className='hover:underline hover:cursor-pointer' onClick={() => handleDownload(file.id)}>{file.friendlyName}</span>
          )
        },
      ]}
      data={data}
      actions={{
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default LeadFileTable;
